module.exports = __webpack_public_path__ + "img/04_sub_uk.9c043021.svg";